export default __webpack_public_path__ + "static/media/gallery_08.801c39c4.jpg";